// extracted by mini-css-extract-plugin
export default {"confirmationModal":"Modal_confirmationModal__AwDXD","isBig":"Modal_isBig__BRMNa"};